<template>
  <tr class="total-tr">
    <td v-if="!hide_first_td"></td>
    <td class="table-strong">TOTAL</td>
    <td class="table-strong" v-if="!hide_predicted">{{ predicted }}&euro;</td>
    <td class="table-strong">{{ sum }}&euro;</td>
    <td :colspan="fill"></td>
  </tr>
</template>
<script>
  import _ from "lodash"
  export default {
    props: {
      clients: {},
      fill: {},
      hide_predicted: {},
      hide_first_td: {},
    },
    computed: {
      predicted() {
        return _.sumBy(this.clients, 'predicted_income')
      },
      sum() {
        return _.sumBy(this.clients, 'generated_money')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/invoices2/TotalTr.vue